import React, { useState, useEffect } from 'react'
import { FaPlusCircle, FaRegTimesCircle } from 'react-icons/fa'
import { IconButton } from '@material-ui/core'

import { useQuery } from '@apollo/client'

import { Q_HEX_COLORS } from 'graphql/query'
import BaseBin from '../BaseBin'
import HexColors from './Display/HexColors'
import CreateForm from './Form/Create'
import styles from './hexColors.module.scss'
import Loading from 'components/Global/Loading'
import NoContents from 'components/Global/NoContents'

const HexColorsBin = () => {
  const [create, setCreate] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const [colors, setColors] = React.useState([])
  const [noContent, setNoContent] = React.useState(false)

  const { refetch } = useQuery(Q_HEX_COLORS)

  const update = () => {
    refetch() &&
      refetch()
        .then(res => {
          setColors(res.data.rHexColor)
          setLoading(false)
          setNoContent(false)
        })
        .catch(err => {
          setNoContent(true)
          console.error(err)
        })
  }

  useEffect(() => {
    update()
  }, [refetch])
  return noContent ? (
    <NoContents />
  ) : (
    <BaseBin
      title="HexColors"
      actions={[
        <IconButton
          className={styles.icn}
          color="primary"
          onClick={() => setCreate(i => !i)}
        >
          {!create ? <FaPlusCircle /> : <FaRegTimesCircle />}
        </IconButton>,
      ]}
    >
      {!create ? (
        !loading ? (
          <HexColors colors={colors} update={update} loading={setLoading} />
        ) : (
          <div className={styles.sktContainer}>{<Loading />}</div>
        )
      ) : (
        //   <EnvironmentCreateForm setCreate={setCreate} />
        <CreateForm
          setCreate={setCreate}
          update={update}
          loading={setLoading}
        />
      )}
    </BaseBin>
  )
}

export default HexColorsBin
